import types from '../../constants';

export function selectUnit(users) {
  return {
    type: types.EXERCISE_RUN_UNIT_SELECT,
    payload: users,
  };
}

export function selectLocation(location) {
  return {
    type: types.EXERCISE_RUN_LOCATION_SELECT,
    payload: location,
  };
}

export function move(users, location) {
  return async (dispatch) => {
    global.socket.emit('user_move', { ids: users, location });
    dispatch({ type: types.SOCKET_ACTION });
  };
}


export function stateChange(users, state) {
  return async (dispatch) => {
    global.socket.emit('set_state', { state });
    dispatch({ type: types.SOCKET_ACTION });
  };
}
